import { RegistryCompanyResponse } from 'generated/api-client';
import { useCompanyRegistrySearch } from 'modules/company/hooks/useCompanyRegistrySearch';
import { extractSiren } from 'modules/company/utils/extractSiren';
import React, { FunctionComponent, useCallback, useState } from 'react';
import { Icon, Search, SearchResultsProps } from 'semantic-ui-react';
import styled from 'styled-components';

const SearchStyled = styled(Search)`
  width: 100%;

  .input {
    width: 100%;
  }

  input {
    margin-left: 5px !important;
    position: relative !important;
  }

  &:focus {
    border-color: #3c8dbc !important;
  }
`;

type Props = {
  onSelectResult?: (result: RegistryCompanyResponse) => void;
};

export const CompanyRegistrySearch: FunctionComponent<Props> = ({
  onSelectResult,
}) => {
  const [open, setOpen] = useState(false);
  const [searchText, setSearchText] = useState('');
  const { results, isLoading } = useCompanyRegistrySearch({ searchText });

  const handleResultSelect = useCallback(
    (result: RegistryCompanyResponse) => {
      setOpen(false);
      onSelectResult?.(result);
    },
    [onSelectResult],
  );

  const handleClear = useCallback(() => {
    setSearchText('');
    setOpen(false);
  }, []);

  const handleBlur = useCallback(() => {
    setOpen(false);
  }, []);

  const resultRenderer = useCallback(
    (result: RegistryCompanyResponse) => (
      <p>
        <b>{result.name}</b> - <i>{extractSiren(result.siret)}</i>
        <br />
        {result.address.streetAddress} {result.address.postalCode}{' '}
        {result.address.city}
      </p>
    ),
    [],
  );

  return (
    <SearchStyled
      open={open && !isLoading && !!searchText}
      input={{
        icon: searchText ? (
          <Icon name="times" link onClick={handleClear} />
        ) : (
          'search'
        ),
        iconPosition: 'right',
      }}
      noResultsMessage={isLoading ? null : 'Pas de résultats'}
      loading={isLoading}
      placeholder="Chercher une entreprise par nom, SIREN, ou SIRET..."
      onBlur={handleBlur}
      onResultSelect={(
        _: unknown,
        data: { result: RegistryCompanyResponse },
      ) => {
        handleResultSelect(data.result);
      }}
      resultRenderer={resultRenderer}
      onSearchChange={(_: unknown, data: { value?: string }) => {
        setOpen(true);
        setSearchText(data.value || '');
      }}
      results={results as SearchResultsProps}
      value={searchText}
      scroll
    />
  );
};
